<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="productIntroductionTemplates">
      <el-button
          slot="toolbar"
          type="primary"
          size="mini"
          @click="$refs.editPage.open(0)">
        新增
      </el-button>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="模板名称">
            <el-input v-model.trim="filter.templateName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="templateName" align="center" label="模板名称"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row.pkid)">编辑</el-button>
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <product-introduction-template-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import constant from "@/util/constant";
  import ProductIntroductionTemplateEdit
    from "@/views/information/ProductIntroductionTemplate/ProductIntroductionTemplateEdit";

  export default {
    name:"ProductIntroductionTemplate",
    components: {ProductIntroductionTemplateEdit, VmTable, VmSearch },
    data() {
      return {
        constant,
        filter: {
          templateName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","/productIntroductionTemplates",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
